const enchants = {
  /* Template */
  // X_ENCHANT: {
  //     id: 0,
  //     name: '',
  //     icon: '',
  // },
  // X_BUFF: {
  //     id: 0,
  //     name: '',
  //     icon: '',
  // },
  FRENZIED_FOCUS: {
    id: 1241762,
    name: 'Frenzied Focus',
    icon: 'ability_warrior_intensifyrage',
  },
};

export default enchants;
